import axios from 'axios'

export default {
  state: {
    complexCompanyList: [],
    complexAllList: [],
    complexItem: {}
  },
  mutations: {
    SET_COMPLEX_LIST(state, data) {
      state.complexCompanyList = data
    },
    SET_ALL_COMPLEX_LIST(state, data) {
      state.complexAllList = data
    },
    SET_COMPLEX_ITEM(state, data) {
      state.complexItem = data
    }
  },
  actions: {
    GET_ALL_COMPLEX_LIST({ commit }) {
      return axios({
        url: `/api/Company/GetAllComplexes`,
        method: 'get'
      }).then(response => {
        commit('SET_ALL_COMPLEX_LIST', response.data)
      })
    },
    GET_COMPLEX_LIST({ commit }, companyId) {
      return axios({
        url: `/api/Company/GetComplexes/${companyId}`,
        method: 'get'
      }).then(response => {
        commit('SET_COMPLEX_LIST', response.data)
      })
    },
    GET_COMPLEX_ITEM({ commit }, id) {
      return axios({
        url: `/api/Company/GetComplex/${id}`,
        method: 'get'
      }).then(response => {
        commit('SET_COMPLEX_ITEM', response.data)
      })
    },
    ADD_COMPLEX({ commit, rootState }, data) {
      const sessionId = rootState.token
      return axios({
        url: `/api/Company/SetComplex/${sessionId}`,
        method: 'post',
        data
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          const { data } = error.response
          return { error: true, message: (data || {}).message }
        })
    },
    REMOVE_COMPLEX_BY_ID({ commit, rootState }, { complexId }) {
      const sessionId = rootState.token
      return axios({
        method: 'POST',
        url: `/api/Company/DeleteComplex/${sessionId}`,
        params: { complexId }
      })
        .then(response => {
          return response.data
        })
        .catch(error => {
          const { data } = error.response
          return { error: true, message: (data || {}).message }
        })
    },
    SET_VIEWED_COMPLEX({ commit }, complexId) {
      axios({
        method: 'POST',
        url: `/api/Company/ViewedComplex/${complexId}`
      })
    }
  },
  getters: {
    getComplexCompanyList: state => build => {
      return state.complexCompanyList.filter(complex => complex.built === build)
    },
    getComplexPageCount: state => count => {
      return Math.ceil(state.complexAllList.length / count)
    },
    getComplexList: state => pagination => {
      const list = state.complexAllList
      return list.slice(
        pagination.page * pagination.count - pagination.count,
        pagination.count * pagination.page
      )
    }
  }
}
